module.exports = __webpack_public_path__ + "img/download-billing-big-hover.557e8936.png";